module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "front"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter01"
    }
  }, [_vm._v("1. "), _c('span', {
    staticClass: "mt"
  }, [_vm._v("The Invitation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. "), _c('span', {
    staticClass: "mt"
  }, [_vm._v("Midsomer Madness")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. "), _c('span', {
    staticClass: "mt"
  }, [_vm._v("The Woman in Black")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. "), _c('span', {
    staticClass: "mt"
  }, [_vm._v("Between the Lines")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. "), _c('span', {
    staticClass: "mt"
  }, [_vm._v("Hector Pulls It Off")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. "), _c('span', {
    staticClass: "mt"
  }, [_vm._v("Liam’s Story")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. "), _c('span', {
    staticClass: "mt"
  }, [_vm._v("Hunting in Full Steel")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coda")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-262d6358","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Toc.vue
// module id = 63
// module chunks = 0